import { Observable } from 'rxjs';
import { HostedGamesService } from '@hosted-games/infra';
import { inject } from '@angular/core';
import { CancelHostedGamePathParams } from '@core-http';

export class RemoveGameCommandHandler {
  private readonly hostedGamesService: HostedGamesService = inject(HostedGamesService);

  removeGame(gameId: string): Observable<void> {
    const pathParams: CancelHostedGamePathParams = { hostedGameId: gameId };

    return this.hostedGamesService.removeGame(pathParams);
  }
}
